export default __webpack_public_path__ + "static/1407-64b581084a2251345f420f6c40c7441b.gif";